
import Image from "next/image";

import { Card, CardContent } from "@/components/ui/card";

interface CardServiceProps {
  service: {
    id: number;
    title: string;
    description: string;
    icon: string;
    principal?: boolean
  };
}


const CardService = ({ service }: CardServiceProps) => {
  return ( 
    <Card className={`${service?.principal ? 'bg-gradient-primary text-white' : ''} 
    p-0 h-full rounded-lg hover:shadow-lg transition-all duration-300 border-none shadow-sm relative group`}>                                                   
      <CardContent className="text-start p-8 pt-0 relative">
        <div className={`flex h-18 w-18 items-center justify-center rounded-lg -mt-2 shadow-sm
         ${service?.principal ? 'bg-white' : 'bg-gradient-primary'}`}
        >
          <Image 
            src={`/services/${service.icon}`} 
            alt={service.title} 
            width={45} 
            height={45} 
            className="group-hover:scale-105 transition-all duration-200"
          />
        </div>
        <h2 className={`${service?.principal ? 'text-white' : 'color-default'} md:text-xl mt-6 font-semibold mb-2`}>
          {service.title}
        </h2>
        <p className={`${service?.principal ? 'text-white' : 'text-muted-foreground'} text-sm lg:text-base leading-relaxed`}>
          {service.description}
        </p>
      </CardContent>
    </Card>
   );
}
 
export default CardService;